/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useCallback, useState } from 'react'

import { Applications } from '../../types/get.applications'

const useApps = (listApps: Applications) => {
  const [appSelected, setAppSelected] = useState<number | null>()

  const handleShowMoreApps = useCallback(() => {
    if (listApps.results.length < 6) {
      return true
    }
    return false
  }, [listApps])

  return {
    appSelected,
    setAppSelected,
    handleShowMoreApps,
  }
}

export default useApps
